/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { CompanyAddress } from 'types/entities/CompanyAddress'
import EditCompanyModalAddressItem from './EditCompanyModalAddressItem'

interface EditCompanyModalAddressListProps {
    addresses: CompanyAddress[]
    onEdit: (address?: CompanyAddress) => void
    onDelete: (address: CompanyAddress) => void
}

const EditCompanyModalAddressList = (
    props: EditCompanyModalAddressListProps
) => {
    const visibleAddresses = props.addresses.filter(
        (a) => a.name !== 'shipping' && a.name !== 'postal'
    )

    if (!visibleAddresses.length) {
        return null
    }

    return (
        <>
            {visibleAddresses.map((address) => (
                <EditCompanyModalAddressItem
                    key={address.id}
                    address={address}
                    onEdit={props.onEdit}
                    onDelete={props.onDelete}
                />
            ))}
        </>
    )
}

export default EditCompanyModalAddressList
